import SafeInnerHtml from './safeInnerHtml'

export default SafeInnerHtml
